import styled from 'styled-components';

export const FeatureInfoContainer = styled.div`
    padding: 12px 20px;
`;

export const TabWrapper = styled.div`
    margin-bottom: 21px;`;

export const NoServiceOffer = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 46px;
    color: rgba(0, 0, 0, 0.38);
`;